import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from 'react';
import { Button } from './Button';
import { MaximizeIcon, MinimizeIcon } from './Icon';
export function FullscreenButton({ element }) {
    const canRequestFullscreen = useMemo(() => !!element && canRequestFullscreenOnElement(element), [element]);
    const isFullscreen = useIsFullscreen();
    if (!canRequestFullscreen) {
        return null;
    }
    return (_jsx(Button, { type: "button", shape: "pill", kind: "secondary", padding: "none", onClick: () => {
            if (isFullscreen) {
                exitFullscreen();
            }
            else {
                if (element) {
                    requestFullscreen(element);
                }
            }
        }, icon: isFullscreen ? _jsx(MinimizeIcon, {}) : _jsx(MaximizeIcon, {}) }));
}
function canRequestFullscreenOnElement(element) {
    return !!(element.requestFullscreen || element.webkitRequestFullscreen);
}
function useIsFullscreen() {
    const [isFullscreen, setIsFullscreen] = useState(() => !!getFullscreenElement());
    useEffect(function handleFullscreenEvents() {
        const onFullscreenChange = () => {
            setIsFullscreen(!!getFullscreenElement());
        };
        document.addEventListener('fullscreenchange', onFullscreenChange);
        document.addEventListener('webkitfullscreenchange', onFullscreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', onFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', onFullscreenChange);
        };
    }, []);
    return isFullscreen;
}
function getFullscreenElement() {
    const element = typeof document !== 'undefined'
        ? document.fullscreenElement || document.webkitFullscreenElement
        : null;
    return element || undefined;
}
function requestFullscreen(element, options) {
    const fn = element.requestFullscreen ||
        element.webkitRequestFullscreen ||
        (() => Promise.reject(new Error('Not supported')));
    return fn.bind(element)(options);
}
async function exitFullscreen() {
    const fn = document.exitFullscreen ||
        document.webkitExitFullscreen ||
        (() => Promise.reject(new Error('Not supported')));
    await fn.bind(document)();
}
